import { useMemo } from 'react';

import { Callable, Optional } from '@vimeo/core/types/generic';

import { T_NEW_MESSAGES_RECEIVED, T_NO_NAME, T_USER_WAS_BLOCKED } from '../../../../translations';
import { CallablePlaceholder } from '../../../../types/general';

export interface IUseNoticeParams {
  blockedUser: Optional<string>;
  showNewMessageNotice: boolean;
  showBlockedUserNotice: boolean;
  scrollChatHistoryToBottom: Callable;
  handleCloseBlockUserNotice: Callable;
}

export interface INoticeProps {
  content: string;
  showing: boolean;
  onClickAction: Callable;
}

export function useNoticeProps({
  showNewMessageNotice,
  scrollChatHistoryToBottom,
  showBlockedUserNotice,
  blockedUser,
  handleCloseBlockUserNotice,
}: IUseNoticeParams): INoticeProps {
  return useMemo(() => {
    if (showNewMessageNotice)
      return {
        showing: showNewMessageNotice,
        content: T_NEW_MESSAGES_RECEIVED,
        onClickAction: scrollChatHistoryToBottom,
      };

    if (showBlockedUserNotice)
      return {
        showing: showBlockedUserNotice,
        content: T_USER_WAS_BLOCKED(blockedUser || T_NO_NAME),
        onClickAction: handleCloseBlockUserNotice,
      };

    return {
      showing: false,
      content: '',
      onClickAction: CallablePlaceholder,
    };
  }, [
    showNewMessageNotice,
    scrollChatHistoryToBottom,
    showBlockedUserNotice,
    blockedUser,
    handleCloseBlockUserNotice,
  ]);
}
